import { AppAction } from '../app.types';

export interface IMapViewerState {
	zoom: Map<string, number>;
	panels: Map<MapViewerPanel, boolean>;
}

export type MapViewerLastViewed = {
	mapId: string;
	title: string;
	mapUrl: string;
};

export enum MapViewerPanel {
	Drawing,
	DrawSquare,
	DrawCircle,
	DrawPencil,
	DrawText,
	DrawArrow,
	Selection,
	Attachement,
	GoogleMaps
}

export const editPanels: MapViewerPanel[] = [
	MapViewerPanel.Selection,
	MapViewerPanel.DrawSquare,
	MapViewerPanel.DrawCircle,
	MapViewerPanel.DrawPencil,
	MapViewerPanel.DrawText,
	MapViewerPanel.DrawArrow
];

export const actionPanels: MapViewerPanel[] = [
	MapViewerPanel.Drawing,
	MapViewerPanel.Attachement,
	MapViewerPanel.GoogleMaps
];

export type MapViewerActions =
	| MapViewerAction
	| MapViewerZoomAction
	| MapViewerPanelAction;
export type MapViewerAction = AppAction<string>;
export type MapViewerZoomAction = AppAction<number> & { mapId: string };
export type MapViewerPanelAction = AppAction<
	| {
			panel: MapViewerPanel;
			open?: boolean;
	  }
	| MapViewerPanel
>;
